import React, {FC} from 'react';

import {AdditionalInfo, Approve} from '@optimaxdev/icons';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';

import {Notification} from '../notification/notification';

type PropsType = {
    item: QuoteItemV2;
};

/**
 * Component for render uhc notification
 */
export const UhcNotification: FC<PropsType> = ({item}) => {
    if (item.isAppliedBenefits)
        return (
            <Notification icon={Approve} type="info">
                Plan Allowance Applied.
            </Notification>
        );
    if (item.isEligibleForApplyBenefits)
        return (
            <Notification icon={Approve} type="info">
                20% Exclusive Discount.{' '}
            </Notification>
        );
    return (
        <Notification icon={AdditionalInfo} type="infoBlack">
            Not covered by your plan.
        </Notification>
    );
};
